import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import SubOrganizationsAPI from '../../../../utils/api/subOrganizationsAPI';

const entity = new ReduxRestEntity({
  name: 'subOrganizations',
  api: SubOrganizationsAPI(),
});

export default entity;
